export enum MicroAdjustmentConfigurations {
  INGREDIENTS = "ingredients",
  PACKAGING = "packaging",
  MANUFACTURING = "manufacturing",
  LOGISTICS = "logistics",
  CDE = "cde",
}
